export default function BackgroundMedia() {
    const isMobile = /iPhone|Android/i.test(navigator.userAgent);
    const styleMedia = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1
    };

  return isMobile ? (
    <img src="/Images/HomePhone.png" alt="background" style={styleMedia} />
  ) : (
    <video style={styleMedia} autoPlay loop muted playsInline>
      <source src={process.env.REACT_APP_HOME_LOADING_VIDEO_BACKGROUND} type="video/mp4" />
    </video>
  );
}